import sanitizeHtml from 'sanitize-html';
import { pageContext } from './page_context';

const defaultAllowedHtmlTags = [
    'h2', 'h3', 'h4', 'a', 'span', 'p', 'br',
    'b', 'strong', 'i', 'em', 'sup', 'ul', 'li', 'ol'
];

const defaultAllowedSchemes = ['http', 'https', 'mailto', 'tel'];

const appendRelTokens = (rel = '', tokens = []) => {
    const relValues = new Set(rel.split(' ').filter(Boolean));
    tokens.forEach((token) => relValues.add(token));
    return Array.from(relValues).join(' ');
};

/**
 * Sanitize innerHTML method
 * @param  {String} innerHtml - the innerHtml property.
 * @param  {Array} allowedTags - An array of allowed tags.
 * @returns {String} - sanitized innerHTML
 */
export const sanitizeInnerHtml = (innerHtml, allowedTags = defaultAllowedHtmlTags) => {
    return sanitizeHtml(replaceBaseUrl(innerHtml), {
        allowedTags,
        allowedAttributes: {
            a: ['href', 'target', 'data-id', 'style', 'rel'],
            span: ['class'],
            p: ['data-id']
        },
        allowedSchemes: defaultAllowedSchemes,
        allowedSchemesByTag: {
            a: defaultAllowedSchemes
        },
        allowProtocolRelative: false,
        transformTags: {
            a: (tagName, attribs) => {
                if (attribs.target === '_blank') {
                    return {
                        tagName,
                        attribs: {
                            ...attribs,
                            rel: appendRelTokens(attribs.rel, ['noopener', 'noreferrer'])
                        }
                    };
                }

                return { tagName, attribs };
            }
        }
    });
};

/**
 * Centralised functionality to perform a replace on /evt/assets path
 * @param {String} content The content that needs to have a replace
 * @param {String} baseUrl The base URL
 * @returns {String} The string or the string with /evt/assets replaced with the baseUrl
 */
export const replaceBaseUrl = (content, baseUrl = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath()) => {
    return typeof content === 'string' && content.indexOf(baseUrl) === -1 ? content.replace(/\/evt\/assets/g, baseUrl) : content;
};
